/* Consent-Verwaltung für die unveröffentlichte Vergleichsfassung. */
(function () {
  'use strict';
  const cc = window.CookieConsent;
  const english = document.documentElement.lang.toLowerCase().startsWith('en');
  if (!cc) return;

  const gate = window.etanaConsentGate;
  let privacy;
  let firstNativeRead = true;
  let writingNative = false;
  let reconciling = false;
  let pending;
  let attempts = 0;
  let retryTimer;
  let nativeError = false;
  let reloadScheduled = false;
  let tagManagerLoaded = false;
  let previous = {};
  let status;

  function accepted(service, category) { return cc.validConsent() && cc.acceptedService(service, category); }
  function hasPendingChoice() {
    const data = cc.validConsent() ? cc.getCookie('data') : null;
    return !!(data && data.shopifyPending);
  }
  function markPending(value) {
    if (cc.validConsent() && hasPendingChoice() !== value) cc.setCookieData({value: {shopifyPending: value}});
  }
  function showStatus(show) {
    if (!status && show) {
      status = document.createElement('div');
      status.setAttribute('role', 'status');
      status.style.cssText = 'position:fixed;bottom:128px;left:12px;max-width:360px;padding:12px;border:1px solid #555;border-radius:4px;background:white;color:#222;z-index:1001;font:inherit';
      status.textContent = english
        ? 'Your privacy choice is saved. Checkout is waiting for confirmation. Please try again shortly.'
        : 'Deine Datenschutzauswahl ist gespeichert. Für die Kasse fehlt noch die Bestätigung. Bitte versuche es gleich erneut.';
      const retry = document.createElement('button');
      retry.type = 'button';
      retry.textContent = english ? 'Try again' : 'Erneut versuchen';
      retry.style.cssText = 'display:block;margin-top:8px;padding:8px;border:1px solid #555;background:white;color:#222;cursor:pointer';
      retry.addEventListener('click', function () { window.location.reload(); });
      status.appendChild(retry);
      document.body.appendChild(status);
    }
    if (status) status.hidden = !show;
  }
  function retryPrivacy() {
    if (attempts < 3 && !retryTimer) retryTimer = window.setTimeout(function () {
      retryTimer = null;
      loadPrivacy();
    }, attempts * 1000);
  }
  function applyShopify(callback) {
    if (!pending) { if (callback) callback(true); return; }
    if (!privacy || writingNative) { if (callback) callback(false); return; }
    const payload = Object.assign({}, pending);
    const signature = JSON.stringify(payload);
    const finish = function (error) {
      writingNative = false;
      if (!error) {
        try {
          const actual = privacy.currentVisitorConsent();
          error = !Object.keys(payload).every(function (key) { return actual[key] === (payload[key] ? 'yes' : 'no'); });
        } catch (readError) { error = true; }
      }
      if (error) {
        nativeError = true;
        showStatus(hasPendingChoice());
        retryPrivacy();
      } else if (pending && JSON.stringify(pending) === signature) {
        pending = null;
        markPending(false);
        nativeError = false;
        showStatus(false);
      }
      if (callback) callback(!error);
      if (!error && pending) applyShopify();
    };
    try {
      const current = privacy.currentVisitorConsent();
      const unchanged = Object.keys(payload).every(function (key) { return current[key] === (payload[key] ? 'yes' : 'no'); });
      if (unchanged) { finish(false); return; }
      writingNative = true;
      privacy.setTrackingConsent(payload, finish);
    } catch (error) { finish(true); }
  }
  function loadPrivacy() {
    attempts += 1;
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') { retryPrivacy(); return; }
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], function (error) {
      if (error || !window.Shopify.customerPrivacy) {
        nativeError = true;
        sync(false);
        showStatus(hasPendingChoice());
        retryPrivacy();
        return;
      }
      privacy = window.Shopify.customerPrivacy;
      sync(false);
    });
  }
  function restrictFromNative() {
    if (!privacy || !cc.validConsent() || writingNative || reconciling || hasPendingChoice()) return false;
    const native = privacy.currentVisitorConsent();
    const revokeAnalytics = native.analytics === 'no' && accepted('shopify-analytics', 'analytics');
    const revokeMarketing = native.marketing === 'no' && cc.acceptedCategory('marketing');
    if (!revokeAnalytics && !revokeMarketing) return false;
    reconciling = true;
    if (revokeAnalytics) cc.acceptService([], 'analytics');
    if (revokeMarketing) cc.acceptService([], 'marketing');
    reconciling = false;
    return true;
  }
  function cleanCookies(flags) {
    const domains = [location.hostname, '.' + location.hostname, '.etana-staubsaugerbeutel.de'];
    domains.forEach(function (domain) {
      if (!flags.s26) cc.eraseCookies(/^(_ga(?:_|$)|_gid$|_gat(?:_|$))/, '/', domain);
      if (!flags.s1) cc.eraseCookies(/^(_gcl(?:_|$)|_gac(?:_|$))/, '/', domain);
    });
    if (!flags.s1) {
      try { window.localStorage.removeItem('_gcl_ls'); } catch (error) { /* Gesperrter Browserspeicher benötigt keine Bereinigung. */ }
    }
  }
  function sync(userChanged) {
    if (reconciling) return;
    if (userChanged) markPending(true);
    if (privacy && firstNativeRead) {
      if (!userChanged && gate.saved) restrictFromNative();
      firstNativeRead = false;
    }
    const flags = {
      s1: accepted('google-ads', 'marketing'),
      s26: accepted('google-analytics', 'analytics'),
      s135: accepted('google-general', 'analytics'),
      s905: accepted('google-tag-manager', 'analytics')
    };
    const nextPolicy = {analytics: flags.s26, marketing: flags.s1,
      history: false, tagmanager: flags.s905,
      shopifyanalytics: accepted('shopify-analytics', 'analytics')};
    const policyChanged = gate && Object.keys(nextPolicy).some(function (key) { return gate.initial[key] !== nextPolicy[key]; });
    const downgrade = gate && Object.keys(nextPolicy).some(function (key) { return gate.initial[key] && !nextPolicy[key]; });
    if (downgrade) gate.tighten(nextPolicy);

    // Lokale Sperren und Widerruf dürfen nicht auf die Shopify-Schnittstelle warten.
    const update = {
      analytics_storage: privacy && flags.s26 ? 'granted' : 'denied',
      ad_storage: privacy && flags.s1 ? 'granted' : 'denied',
      ad_user_data: privacy && flags.s1 ? 'granted' : 'denied',
      ad_personalization: privacy && flags.s1 ? 'granted' : 'denied'
    };
    const vendors = ['s40', 's23', 'c40453', 's1475', 'c23114', 's1097', 's971'];
    Object.keys(flags).forEach(function (id) {
      update['cmp_' + id] = privacy && flags[id] ? 'granted' : 'denied';
      if (privacy && flags[id]) vendors.push(id);
    });
    update.cmp_purpose_c51 = 'granted';
    update.cmp_purpose_c54 = privacy && cc.acceptedCategory('analytics') ? 'granted' : 'denied';
    update.cmp_purpose_c52 = privacy && cc.acceptedCategory('marketing') ? 'granted' : 'denied';
    window.gtag('consent', 'update', update);
    cleanCookies(flags);
    window.dataLayer.push({event: 'cmpEvent', cmpRegulation: 'GDPR', cmpGDPR: 1,
      cmpConsentVendors: ',' + vendors.join(',') + ',', cmpVendorsConsent: ',' + vendors.join(',') + ',',
      cmpCustomVendorsConsent: ',' + vendors.join(',') + ','});

    // Nur eine tatsächlich getroffene Entscheidung weitergeben oder deren ausstehende Übertragung wiederholen.
    pending = hasPendingChoice() ? {analytics: nextPolicy.shopifyanalytics, marketing: flags.s1,
      preferences: false, sale_of_data: false} : null;
    const revoked = Object.keys(previous).some(function (id) { return previous[id] && !flags[id]; });
    previous = flags;
    if ((policyChanged || revoked) && !reloadScheduled) {
      reloadScheduled = true;
      let reloaded = false;
      const reload = function () { if (!reloaded) { reloaded = true; window.location.reload(); } };
      applyShopify(reload);
      window.setTimeout(reload, 1000);
      return;
    }
    applyShopify();
    if (privacy && flags.s905 && !tagManagerLoaded && !reloadScheduled) {
      const source = document.getElementById('etana-gtm-loader');
      if (source) {
        tagManagerLoaded = true;
        const script = document.createElement('script');
        script.textContent = source.textContent;
        document.head.appendChild(script);
      }
    }
    if (nativeError) showStatus(hasPendingChoice());
  }
  document.addEventListener('visitorConsentCollected', function () {
    if (restrictFromNative()) sync(false);
  });
  function guardCheckout(event) {
    if (cc.validConsent() && !hasPendingChoice()) return;
    const path = event.composedPath();
    const checkout = path.some(function (element) {
      return element.matches && (element.matches('[name="checkout"], .shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart')
        || (element.matches('a[href]') && /^\/checkout(?:[/?#]|$)/.test(element.getAttribute('href'))));
    }) || (event.type === 'submit' && event.submitter && event.submitter.name === 'checkout');
    if (!checkout) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!cc.validConsent()) { cc.show(true); return; }
    showStatus(true);
    // Fehlgeschlagene Feature-Ladevorgänge werden von Shopify pro Dokument zwischengespeichert.
    if (nativeError) { window.location.reload(); return; }
    if (!retryTimer && !writingNative) { attempts = 0; loadPrivacy(); }
  }
  document.addEventListener('click', guardCheckout, true);
  document.addEventListener('submit', guardCheckout, true);
  cc.run({
    mode: 'opt-in', revision: 1, hideFromBots: false,
    cookie: {name: 'etana_consent', domain: '.etana-staubsaugerbeutel.de', expiresAfterDays: function (type) { return type === 'all' ? 365 : 14; }, sameSite: 'Lax', secure: true},
    guiOptions: {
      consentModal: {layout: 'box', position: 'middle center', equalWeightButtons: true},
      preferencesModal: {layout: 'box', equalWeightButtons: true}
    },
    onConsent: function () { sync(!gate.saved); }, onChange: function () { sync(true); },
    categories: {
      necessary: {enabled: true, readOnly: true},
      analytics: {services: {
        'google-analytics': {label: 'Google Analytics', cookies: [{name: /^(_ga|_gid|_gat)/}, {name: /^(_ga|_gid|_gat)/, domain: '.etana-staubsaugerbeutel.de'}]},
        'google-general': {label: 'Google General'},
        'google-tag-manager': {label: 'Google Tag Manager'},
        'shopify-analytics': {label: english ? 'Shopify Analytics and Judge.me analytics' : 'Shopify Analytics und Judge.me-Analyse'}
      }},
      marketing: {services: {'google-ads': {label: 'Google Ads', cookies: [{name: /^(_gcl|_gac)/}, {name: /^(_gcl|_gac)/, domain: '.etana-staubsaugerbeutel.de'}]}}}
    },
    language: {
      default: english ? 'en' : 'de',
      translations: {de: {
        consentModal: {
          title: "Cookies & Datenverarbeitung",
          description: "Mit deiner Einwilligung nutzen wir und bis zu 3 Anbieter (Google, Shopify, Judge.me) Cookies und Geräte- sowie Nutzungsdaten für Nutzungsanalyse, Werbeerfolgsmessung und personalisierte Werbung. Google erstellt dabei websiteübergreifende Nutzungsprofile. Datenverarbeitung auch außerhalb des Europäischen Wirtschaftsraums möglich. Freiwillig; Einkauf auch ohne Einwilligung. Widerruf jederzeit für die Zukunft über „Datenschutz-Einstellungen“ im Seitenfuß. Details: Einstellungen und Datenschutzerklärung.",
          acceptAllBtn: 'Alle akzeptieren', acceptNecessaryBtn: 'Alles ablehnen',
          showPreferencesBtn: 'Erweiterte Einstellungen',
          footer: '<a href="/policies/privacy-policy">Datenschutzerklärung</a> <a href="/policies/legal-notice">Impressum</a>'
        },
        preferencesModal: {
          title: 'Datenschutz-Einstellungen',
          acceptAllBtn: 'Alle akzeptieren', acceptNecessaryBtn: 'Alles ablehnen',
          savePreferencesBtn: 'Speichern + Beenden', closeIconLabel: 'Schließen',
          serviceCounterLabel: 'Dienst|Dienste',
          sections: [
            {title: 'Deine Auswahl', description: 'Optionale Dienste bleiben bis zu deiner Zustimmung ausgeschaltet. Eine Ablehnung verhindert deinen Einkauf nicht.'},
            {title: 'Funktion', description: 'Ecultor GmbH &amp; Co. KG betreibt diesen Shop mit Shopify International Limited. Notwendige Funktionen ermöglichen Warenkorb, Sicherheit, deine Einwilligungsauswahl und den Einkauf. Zahlungsdienste wie PayPal werden entsprechend der gewählten Zahlungsart eingesetzt; Produktbewertungen werden durch Judge.me angezeigt. Unsere Einwilligungsauswahl wird bei voller Zustimmung für 365 Tage, sonst für 14 Tage gespeichert. Informationen zu weiteren Dienstleistern und technischen Ressourcen stehen in der Datenschutzerklärung.', linkedCategory: 'necessary'},
            {title: 'Messung', description: 'Google Ireland Limited: Google Analytics zur Auswertung von Seitenaufrufen und Nutzung; Google General für damit verbundene Google-Dienste; Google Tag Manager zur gesteuerten Ausführung der Tags. Shopify International Limited und Judge.me: Nutzungsanalyse über Shopifys gemeinsame Analysefreigabe. Verarbeitet werden unter anderem technische Geräteinformationen, Seitenaufrufe und Interaktionen. <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Google-Datenschutz</a> · <a href="https://www.shopify.com/legal/privacy" target="_blank" rel="noopener">Shopify-Datenschutz</a> · <a href="https://judge.me/privacy" target="_blank" rel="noopener">Judge.me-Datenschutz</a>. Konkrete Speicherdauern und Übermittlungsgrundlagen stehen in unserer Datenschutzerklärung.', linkedCategory: 'analytics'},
            {title: 'Marketing', description: 'Google Ads (Google Ireland Limited): Werbeerfolgsmessung, Zuordnung von Käufen zu Anzeigen und personalisierte Werbung anhand von Nutzungs- und Geräteinformationen. Die Auswahl wird an Google und Shopify weitergegeben. Einzelheiten zu Empfängern, Speicherdauer und Drittlandübermittlungen: <a href="/policies/privacy-policy">Datenschutzerklärung</a> und <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Google-Datenschutz</a>.', linkedCategory: 'marketing'},
            {title: 'Weitere Informationen', description: '<a href="/policies/privacy-policy">Datenschutzerklärung</a>'}
          ]
        }
      }, en: {
        consentModal: {
          title: "Cookies & Data Processing",
          description: "With your consent, we and up to 3 providers (Google, Shopify and Judge.me) use cookies and device and usage data for usage analytics, advertising performance measurement and personalised advertising. Google also creates user profiles across websites. Data may be processed outside the European Economic Area. Consent is voluntary; you can shop without it. You can withdraw your consent at any time, with effect for the future, via “Privacy settings” in the footer. For details, see the settings and our privacy policy.",
          acceptAllBtn: 'Accept all', acceptNecessaryBtn: 'Reject all', showPreferencesBtn: 'Advanced settings',
          footer: '<a href="/policies/privacy-policy">Privacy policy</a> <a href="/policies/legal-notice">Legal notice</a>'
        },
        preferencesModal: {
          title: 'Privacy settings', acceptAllBtn: 'Accept all', acceptNecessaryBtn: 'Reject all',
          savePreferencesBtn: 'Save preferences', closeIconLabel: 'Close', serviceCounterLabel: 'service|services',
          sections: [
            {title: 'Your choice', description: 'Optional services remain disabled until you consent. You can change or withdraw your choice at any time.'},
            {title: 'Essential', linkedCategory: 'necessary', description: 'Ecultor GmbH &amp; Co. KG operates this shop using Shopify International Limited. Essential functions support the cart, security, your consent choice and shopping. Payment services such as PayPal are used according to your selected payment method; Judge.me displays product reviews. Your choice is stored for 365 days with full consent, otherwise for 14 days. See our privacy policy for further providers and technical resources.'},
            {title: 'Analytics', linkedCategory: 'analytics', description: 'Google Ireland Limited provides Google Analytics for usage measurement, related Google services and Google Tag Manager for controlled tag execution. Shopify International Limited and Judge.me receive a shared Shopify analytics choice. Data includes device information, page views and interactions. For recipients, storage periods and international transfers, see our <a href="/policies/privacy-policy">privacy policy</a>, <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Google</a>, <a href="https://www.shopify.com/legal/privacy" target="_blank" rel="noopener">Shopify</a> and <a href="https://judge.me/privacy" target="_blank" rel="noopener">Judge.me</a>.'},
            {title: 'Marketing', linkedCategory: 'marketing', description: 'Google Ads (Google Ireland Limited) measures advertising results, attributes purchases to ads and personalises advertising using usage and device information. Your choice is passed to Google and Shopify. See our <a href="/policies/privacy-policy">privacy policy</a> and <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Google privacy policy</a> for storage periods and international transfers.'},
            {title: 'Further information', description: '<a href="/policies/privacy-policy">Privacy policy</a>'}
          ]
        }
      }}
    }
  }).then(function () { if (!cc.validConsent()) sync(false); loadPrivacy(); });

}());
